var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3"},[_c('page-title',{attrs:{"title":"Clients"}}),_c('hr'),_c('filtered-table',{attrs:{"settings":_vm.tableSettings},on:{"rowClicked":_vm.onRowClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }